module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAABOElEQVRoQ+3YUWoCQRCE4WoJ5FUk9z9giJADqCMLSx4C6s5U1bBI+aoNH/827DiFnX9q5z4EyD6hFExBtgA7nx1MQbYAO58dTEG2ADufHUxBtgA7nx1Mwf8FWmsHAEcAv1V1Ywu9mu/awRX3BeADwAXAjxvZC/wEcAL+/q7akV3A5XG01qYiu4GzkUPAJ8hzVV1fLX7P98PAWUgKOANJA91ICdCJlAFdSCnQgZQD1UgLUIm0AVVIK1CBtAMfIavqe8srL8AHx7PNhwprQcXZ0QZU4JYdtQBVOAtQiZMD1Tgp0IGTAV04CdCJo4FuHAWcgRsGzsINAWfiuoGzcSPA5W5wv9dv6+FzvxeYW07A6t9YTjNKZIBszRRMQbYAO58dTEG2ADufHUxBtgA7nx1MQbYAO58dfPuCdyPwyFHp2x8VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/xiangyou.png
// module id = LMz5
// module chunks = 1